export default __webpack_public_path__ + "static/media/7.cd46597a.png";